/**
 * "Back" on every step of the booking form.
 *
 * The step rail at the top can already jump between completed steps, but that
 * is a control people learn, not one they reach for. Going back is the most
 * ordinary thing a guest does — they picked 8pm, saw it was the last table,
 * and want to look at 7:30 again — and a form without a visible Back sends
 * them to the browser's button, which on an iframe embed exits the widget
 * entirely and loses everything they typed.
 *
 * The arrow is a logical character, not a literal one: `‹` renders pointing
 * left in English and the mirrored form in Arabic, because the browser flips
 * bracket-class characters with the paragraph direction. A hardcoded "←" would
 * point out of the page in Arabic.
 */

import { useTranslation } from 'react-i18next';

export function BackButton({ onClick, label }: { onClick: () => void; label?: string }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 self-start rounded-lg px-1 py-2 text-sm font-medium text-brand-ink-soft transition-colors hover:text-brand-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-bronze"
    >
      <span aria-hidden="true">{'‹'}</span>
      {label ?? t('widget.back')}
    </button>
  );
}
